<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">部所検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search"
          class="btn-search"
          v-permit.SHARP_DIVISION_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-btn @click="add" v-permit.SHARP_DIVISION_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          v-permit.SHARP_DIVISION_EDIT.SHARP_DIVISION_DETAIL
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length !== 1"
          @click="remove"
          v-permit.SHARP_DIVISION_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="部所CD" v-model="query.code" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="部所名称" v-model="query.name" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-select
                :items="types"
                clearable
                item-text="name"
                item-value="code"
                label="部所階層"
                v-model="query.type"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td :key="head.text" v-for="head in headers">
            {{ props.item[head.value] }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: '部所CD', value: 'code', sortable: false },
        { text: '部所名称', value: 'name', sortable: false },
        { text: '部所階層', value: 'desc', sortable: false },
        { text: '所属事業本部', value: 'buName', sortable: false },
        { text: '所属企業', value: 'companyName', sortable: false },
      ],
      types: [
        { code: 'BU', name: '事業本部', sortable: false },
        { code: 'DEPARTMENT', name: '事業部', sortable: false },
        { code: 'BUSINESS_UNIT', name: 'BU', sortable: false },
      ],
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
    }
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/divisions', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    add() {
      this.$router.push('/M0041/new')
    },
    edit() {
      this.$router.push({
        //path: '/M0041/Edit',
        name: 'EditM0041',
        query: { id: this.selected[0].id },
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map((s) => {
              return this.$http.delete(`/divisions/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
            this.$message('', '削除成功')
          })
        }
      )
    },
    back() {
      this.$router.go(-1)
    },
  },
  mounted() {
    this.$loadParams()
  },
}
</script>
